module.exports = __webpack_public_path__ + "img/tra_bg_ven@2x.d1d6d4ef.png";